<template>
  <div>
    <div class="container pl-3 pr-3">
      <!-- <div class="block">
              <p><strong>Hello Traveler,</strong><br>
              Per your admin rules, here are the dates for your meeting*:
              </p>
            </div> -->
      <div class="columns">
              <div class="column" v-if="meetingInfo.meeting.earliestArrival.date">
                <span class="is-size-7 is-uppercase has-text-grey">Arrive no earlier than</span>
                <br>
                <strong>
                  {{ $moment(meetingInfo.meeting.earliestArrival.date).format('ddd, MMM D') }}
                </strong>
                <br>
                <span class="">
                  {{ this.meetingInfo.meeting.earliestArrival.time ? ` at ${$date.convertTime(this.meetingInfo.meeting.earliestArrival.time)}` : '' }}
                </span>
              </div>
              <div class="column" v-if="meetingInfo.meeting.latestArrival.date">
                <span class="is-size-7 is-uppercase has-text-grey">Arrive no later than</span>
                <br>
                <strong>
                  {{ $moment(this.meetingInfo.meeting.latestArrival.date).format('ddd, MMM D') }}
                </strong>
                <br>
                <span class="">
                  {{ this.meetingInfo.meeting.latestArrival.time ? ` at ${$date.convertTime(this.meetingInfo.meeting.latestArrival.time)}` : '' }}
                </span>
              </div>
              <div class="column" v-if="meetingInfo.meeting.earliestDeparture.date">
                <span class="is-size-7 is-uppercase has-text-grey">Depart no earlier than</span>
                <br>
                <strong>
                {{ $moment(this.meetingInfo.meeting.earliestDeparture.date).format('ddd, MMM D') }}
                </strong>
                <br>
                <span class="">
                  {{ $date.convertTime(this.meetingInfo.meeting.earliestDeparture.time) ? `at ${$date.convertTime(this.meetingInfo.meeting.earliestDeparture.time)}` : '' }}
                </span>
              </div>
              <div class="column" v-if="meetingInfo.meeting.latestDeparture.date">
                <span class="is-size-7 is-uppercase has-text-grey">Depart no later than</span>
                <br>
                <strong>{{ $moment(meetingInfo.meeting.latestDeparture.date).format('ddd, MMM D') }}</strong>
                <br>
                <span class="">
                  {{ $date.convertTime(this.meetingInfo.meeting.latestDeparture.time) ? `at ${$date.convertTime(this.meetingInfo.meeting.latestDeparture.time)}` : '' }}
                </span>
              </div>
            </div>
      <!-- <p class="has-text-centered is-size-7"><sup>*</sup>Flight results may be filtered out based on the dates and time restrictions placed by your Admin.</p> -->
    </div>
  </div>
</template>

<script>
  import meetingsMixin from "@/mixins/meetingsMixin";

  export default {
    name: "MeetingDatesInfoForUser",
    mixins: [meetingsMixin],
  }
</script>

<style scoped lang="scss">

</style>